import formatDecimal from "./formatDecimal.js";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/~/d3-format/src/exponent.js
// module id = Zcqu
// module chunks = 0